import {createContext, useContext, useEffect, useState} from "react";
import {LevelData} from "./models/levelData";
import {AppApi} from "./appApi";

interface AppProviderProps {
    children: React.ReactNode;
}

interface AppContextData {
    startState: boolean;
    setStartState(state: boolean): void;
    selectedLevel: LevelData | undefined;
    setSelectedLevel(level: LevelData | undefined): void;
    levels: LevelData[];
    refreshLevels(): Promise<void>;
}

const AppContext = createContext<AppContextData>({} as AppContextData);

export function AppProvider(props: AppProviderProps) {
    const [startState, setStartState] = useState<boolean>(true);
    const [selectedLevel, setSelectedLevel] = useState<LevelData | undefined>(undefined);
    const [levels, setLevels] = useState<LevelData[]>([]);

    useEffect(() => {
        refreshLevels();
    }, []);

    async function refreshLevels(): Promise<void> {
        const levels = await AppApi.listLevels();
        setLevels(levels);
    }

    return (
        <AppContext.Provider
            value={{
                startState, setStartState,
                selectedLevel, setSelectedLevel,
                levels, refreshLevels
            }}>
            {props.children}
        </AppContext.Provider>
    )
}

export const useApp = () => useContext(AppContext);